export default __webpack_public_path__ + "static/media/meme_text.f8568e74.png";